import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { PageHeader } from "@/components/common/Loader";
import { Field, TextInput } from "@/components/common/Forms";
import { FilePicker } from "@/components/common/Files";
import { api, errMsg, useFetch } from "@/lib/api";

export default function NewTicket() {
  const nav = useNavigate();
  const { data: cats } = useFetch("/ticket-categories");
  const [params] = useSearchParams();
  const machine = params.get("macchinario") || "";
  const [category, setCategory] = useState("");
  const [subject, setSubject] = useState(machine ? `Richiesta informazioni: ${machine}` : "");
  const [description, setDescription] = useState(machine
    ? `Buongiorno, vorrei ricevere informazioni sul macchinario ${machine}: caratteristiche, prezzo e condizioni.\nPotete farmi contattare dal mio commerciale di riferimento?\nGrazie.`
    : "");
  useEffect(() => {
    if (machine && cats && !category) {
      const c = cats.find((x) => x.name.toLowerCase().includes("macchinari")) || cats.find((x) => x.name === "Prodotto");
      if (c) setCategory(c.id);
    }
  }, [machine, cats, category]);
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!category) return toast.error("Scegli una categoria");
    setBusy(true);
    const fd = new FormData();
    fd.append("category_id", category);
    fd.append("subject", subject);
    fd.append("description", description);
    if (machine) fd.append("machine", machine);
    files.forEach((f) => fd.append("files", f));
    try {
      const r = await api.post("/tickets", fd);
      toast.success(`Richiesta ${r.data.code} inviata. Ti risponderemo al più presto.`);
      nav(`/assistenza/${r.data.id}`, { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <Link to="/assistenza" className="btn-link">← Assistenza</Link>
      <div className="mt-6"><PageHeader eyebrow="Nuova richiesta" title="Come possiamo aiutarti?" /></div>
      <form onSubmit={submit} className="space-y-6" data-testid="new-ticket-form">
        <Field label="Categoria *">
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger data-testid="ticket-category-select" className="bg-ivory-deep rounded-xl h-11"><SelectValue placeholder="Scegli l'argomento" /></SelectTrigger>
            <SelectContent>
              {(cats || []).map((c) => <SelectItem key={c.id} value={c.id} data-testid={`ticket-category-option-${c.id}`}>{c.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </Field>
        <Field label="Oggetto *"><TextInput data-testid="ticket-subject-input" value={subject} onChange={(e) => setSubject(e.target.value)} required maxLength={160} /></Field>
        <Field label="Descrizione *">
          <Textarea data-testid="ticket-description-input" value={description} onChange={(e) => setDescription(e.target.value)} required rows={7}
            className="bg-ivory-deep rounded-xl" placeholder="Raccontaci con calma cosa ti serve: più dettagli ci dai, più velocemente potremo aiutarti." />
        </Field>
        <Field label="Allegati" hint="Foto o PDF, fino a 20 MB ciascuno">
          <FilePicker files={files} setFiles={setFiles} accept=".pdf,.png,.jpg,.jpeg,.webp,.heic" testid="ticket-files" label="Aggiungi foto o PDF" />
        </Field>
        <button data-testid="ticket-submit-btn" disabled={busy} className="btn-gold w-full sm:w-auto">{busy ? "Invio…" : "Invia la richiesta"}</button>
      </form>
    </div>
  );
}
